@if (isVisible()) {
  <nz-modal
    [nzVisible]="isVisible()"
    [nzFooter]="null"
    [nzClosable]="false"
    [nzMaskClosable]="false"
    [nzCentered]="true"
    [nzWidth]="620"
    (nzOnCancel)="close()"
  >
    <ng-container *nzModalContent>
      <div class="terms-modal">
        <button
          type="button"
          class="close-btn"
          (click)="close()"
          aria-label="Close"
        >
          <span nz-icon nzType="close"></span>
        </button>

        <div class="icon-wrapper">
          <span
            nz-icon
            nzType="exclamation-circle"
            nzTheme="outline"
            class="warning-icon"
          >
          </span>
        </div>

        <h1 class="title">
          {{ i18n.langString("service_conditions_title_line1") }}
          <br />
          {{ i18n.langString("service_conditions_title_line2") }}
        </h1>

        <p class="description">
          {{ i18n.langString("service_conditions_description_1") }}
        </p>

        <a (click)="redirectToServiceCondition()" class="anchor-text">
          {{ i18n.langString("view_full_service_conditions") }}
        </a>

        <div class="actions">
          <button
            nz-button
            nzType="primary"
            class="accept-btn"
            (click)="acceptAndContinue()"
          >
            <span nz-icon nzType="check-circle" nzTheme="outline"></span>
            {{ i18n.langString("accept_and_continue") }}
          </button>

          <button nz-button class="later-btn" (click)="acceptLater()">
            {{ i18n.langString("accept_later") }}
          </button>
        </div>
      </div>
    </ng-container>
  </nz-modal>
}
